import React from 'react';

export default ({ slug }) => {
  return <div id={slug} />;
};
